module.exports = __webpack_public_path__ + "img/asset-account-fund.9e88d159.svg";